const getCheckboxFilters = (checkboxFilters, name, value) => {
  if (typeof value === 'string') {
    if (value !== 'off') checkboxFilters.push([name, value]);
  } else if (value) checkboxFilters.push(name);
};

export default getCheckboxFilters;
